import React from 'react';
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';



const ActionButtons = () => {
  const navigate = useNavigate();

	return (
		<div className="container text-center my-4">
		<h2 className="mb-4 fw-bold">Welcome to Cakery</h2>
		<div className="d-flex flex-column flex-md-row justify-content-center gap-3">
		<span
			className="btn btn-lg px-4 rounded-pill custom-cake-btn"
			onClick={() => navigate("/bakery-search")}
		>
			I want a Custom Cake
		</span>
		<span
			className="btn btn-lg px-4 rounded-pill"
			style={{ backgroundColor: "#FEA2C2", color: "#fff", border: "none" }}
			onClick={() => navigate("/bakery-creation")}
		>
			I'm a Baker
		</span>
		
		</div>
	</div>
		);
};

const LandingPage = () => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center vh-100"
      style={{ background: 'linear-gradient(#F8F4F1,  #FEA2C2)' }}
    >
      <img
        src="/cakerylogo.png"
        alt="Cakery Logo"
        className="mb-4"
        style={{ maxWidth: '200px' }}
      />
      <ActionButtons />
    </div>
  );
};

export default LandingPage;
